import { Platform } from '../types/platform';
import { PlatformApi } from '../types/platform-api';
import { WebPlatformApi } from '../platforms/web';
import { PlatformConfig } from '../types/platform-config';
import { assertNever } from '@tofu/utils';
import { DiscordActivityPlatformApi } from '../platforms/discord-activity';

function detectPlatform(defs: PlatformConfig): Platform {
  const isDiscordActivity = safeIsDiscordActivity();
  if (isDiscordActivity) return Platform.DiscordActivity;

  return Platform.Web;
}

function safeIsDiscordActivity(): boolean {
  // the discord embedded sdk could be used to detect, but it is async so let's try using this synchronous check
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('frame_id'); // lol
  } catch {
    return false;
  }
}

export function getPlatformApi(config: PlatformConfig): PlatformApi {
  const platform = detectPlatform(config);
  switch (platform) {
    case Platform.DiscordActivity: {
      const platformApi = new DiscordActivityPlatformApi(config);
      platformApi.initialize();
      return platformApi;
    }
    case Platform.Web: {
      const platformApi = new WebPlatformApi();
      platformApi.initialize();
      return platformApi;
    }
    default:
      return assertNever(platform) as unknown as PlatformApi;
  }
}
